import type { Move } from '../../../schemas/move';

/**
 * Archetipi del Ranger (manuale V1, rr. 5195-5201).
 *
 * 5 mosse di tipo `class_special`. Pattern razza-tematico standard.
 *
 * **Archetipo Elfo**: l'effetto «qualsiasi ruolo *intraprendi un viaggio
 * pericoloso* riesce automaticamente come 10+» è riferito direttamente
 * dalla mossa iniziale *Ramingo* e dalla sua sostituta *Grampasso*. Il
 * trigger cross-archetipo resta description-only (non strutturato).
 */

const archetipoUmano: Move = {
  id: 'ranger.archetipo-umano',
  name: 'Archetipo: Umano',
  type: 'class_special',
  classId: 'ranger',
  trigger: 'Quando ti *accampi* in un dungeon o in una città',
  description: 'Non hai bisogno di consumare una *razione*.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoElfo: Move = {
  id: 'ranger.archetipo-elfo',
  name: 'Archetipo: Elfo',
  type: 'class_special',
  classId: 'ranger',
  trigger: 'Quando *intraprendi un viaggio pericoloso* attraverso le terre selvagge',
  description:
    'Qualsiasi ruolo tu assuma, riesci automaticamente come se avessi ottenuto un 10+.\n\n**NB**: questo archetipo è riferito direttamente dalle mosse *Ramingo* (iniziale) e *Grampasso* (L6-10), che trasformano in 10+ il peggiore dei risultati di viaggio pericoloso quando il PG ha questo archetipo.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNano: Move = {
  id: 'ranger.archetipo-nano',
  name: 'Archetipo: Nano',
  type: 'class_special',
  classId: 'ranger',
  trigger: 'Quando ti *accampi*',
  description:
    "Puoi, a tua scelta, creare 1 utilizzo di Attrezzatura da Avventuriero o di *munizioni* (del tipo che vuoi), o eseguire una piccola riparazione su un oggetto d'equipaggiamento.",
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoHalfling: Move = {
  id: 'ranger.archetipo-halfling',
  name: 'Archetipo: Halfling',
  type: 'class_special',
  classId: 'ranger',
  trigger: 'Quando stai saccheggiando in cerca di provviste',
  description:
    'Trovi sempre 1d4 utilizzi di Razioni da Dungeon, se ciò è anche solo minimamente plausibile.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoMezzorco: Move = {
  id: 'ranger.archetipo-mezzorco',
  name: "Archetipo: Mezz'orco",
  type: 'class_special',
  classId: 'ranger',
  trigger:
    'Quando torni in un luogo dove ti sei fatto notare per la tua forza, coraggio o spietatezza in una precedente sessione',
  description:
    'La tua reputazione ti precede. Se vieni riconosciuto, sarai inevitabilmente al centro della scena: tutti sanno chi sei e, anche i tuoi nemici, ti temono o ti rispettano per quello che hai fatto.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const rangerArchetypeMoves: readonly Move[] = [
  archetipoUmano,
  archetipoElfo,
  archetipoNano,
  archetipoHalfling,
  archetipoMezzorco,
] as const;
